import React from 'react'
import IconBan from 'front-end/src/components/common/icon/IconBan'
import { Trans } from '@lingui/macro'
import { Box } from 'front-end/src/components'

export const OrganisationSuspendedError = () => (
  <Box className="Auth__noAccess">
    <IconBan />
    <h2>
      <Trans>This organisation has been suspended</Trans>
    </h2>
  </Box>
)
